import React from 'react';
import { createAxios, logNative } from '../../utils/utils';
import Toast from '../../components/Toast/Toast';
import { ORDER_REFUND_82, GAME_REFUND_84, APP_DEVICE_REFUND_88 } from '../../config';

export default {
  async orderRefund({ tradeNo, refundAmount }) {
    const axios = await createAxios('isNeedUser');
    const res = await axios.get(ORDER_REFUND_82, { params: { tradeNo, refundAmount } });
    try {
      if (res.data.status === 0) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      logNative(`logging error${error}`, error);
      return false;
    }
  },

  async orderDeviceRefund({ deviceId, tradeNo, refundAmount }) {
    const axios = await createAxios('isNeedUser');
    const res = await axios.get(APP_DEVICE_REFUND_88, {
      params: { deviceId, tradeNo, refundAmount },
    });
    try {
      if (res.data.status === 0) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      logNative(`logging error${error}`, error);
      return false;
    }
  },
  async gameRefund({ orderId }) {
    const axios = await createAxios('isNeedUser');
    const res = await axios.get(GAME_REFUND_84, { params: { orderId } });
    try {
      return res.data;
    } catch (error) {
      logNative(`logging error${error}`, error);
      return false;
    }
  },
};
